var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ow-information-bulb tooltip is-tooltip-multiline is-tooltip-pre is-tooltip-primary",class:_vm.options,attrs:{"tabindex":"0","data-tooltip":_vm.text}},[_c('span',{staticClass:"ow-ic ow-ic-help-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }